import { render, staticRenderFns } from "./Quienes.vue?vue&type=template&id=2c82e013&lang=pug"
import script from "./Quienes.vue?vue&type=script&lang=js"
export * from "./Quienes.vue?vue&type=script&lang=js"
import style0 from "./Quienes.vue?vue&type=style&index=0&id=2c82e013&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports